import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3447 2.51182C15.4276 3.06649 18.9305 4.36195 19.5264 4.96203C20.1613 5.60199 20.1514 6.10821 20.1074 8.54407C20.0904 9.51607 20.0664 10.8442 20.0664 12.6701C20.0663 17.7392 15.6124 20.3038 13.4072 21.2629C13.087 21.4021 12.7402 21.1599 12.7402 20.8107V2.98546C12.7403 2.66595 13.036 2.4296 13.3447 2.51182ZM10.6328 2.52159C10.9424 2.43764 11.24 2.67452 11.2402 2.99522V20.8068C11.2401 21.1561 10.8926 21.3975 10.5723 21.258C8.36467 20.2965 3.92 17.735 3.91991 12.6701C3.91991 10.8353 3.89492 9.50922 3.87792 8.53724C3.83392 6.10332 3.824 5.59604 4.46093 4.96007C5.0432 4.37907 8.55519 3.08497 10.6328 2.52159Z",
		fill: "currentColor"
	})
});
export default SvgShieldFill;
